import React from "react";
import "./Cards.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import rightArrowWhite from "../../../../../assets/images/rightArrowWhite.svg";

const Cards = (props) =>{
    const { title = null, classNameStyle = null, cardIconSrc = null, description = null, link } = props;
    const history = useHistory();
    return(
        <div className={`cards-container ${classNameStyle}`} >
            <a
            href={link}
             onClick={(e) => {
                e.preventDefault();
                history.push(link);
            }} >
                <div className="cards-upper-section">
                    <div className="icon-title">
                        <span className="cards-icon-container">
                            <img src={cardIconSrc} alt={title}/>
                        </span>
                        <span> {title} </span>
                    </div>
                    <div>
                        <img src={rightArrowWhite} alt="Right Arrow"/>
                    </div>
                </div>
                <div class="cards-divider"></div>
                <div className="cards-lower-section">
                    {description}
                </div>
            </a>
        </div>
    )
}

export default Cards;